export default __webpack_public_path__ + "static/media/history.9a495582.svg";